
interface GymHeaderProps {
  isNew?: boolean;
}

export const GymHeader = ({ isNew }: GymHeaderProps) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-primary">
        {isNew ? "Nuevo Gimnasio" : "Información del Gimnasio"}
      </h3>
      <p className="text-sm text-muted-foreground">
        {isNew 
          ? "Ingresa los datos para crear un nuevo gimnasio"
          : "Gestiona la información de tu gimnasio"
        }
      </p>
    </div>
  );
};
